import styled from 'styled-components'
import { BaseInput, BaseMaskedInput } from 'components/Inputs/Base'
import { LookButton, buttonLook } from 'components/Buttons/look'
import { Link } from 'react-router-dom'
import { NumericFormat } from 'react-number-format'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 10px;
`

export const CheckRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 3px;

  label, p {
    cursor: pointer;
    margin-bottom: 1px;
  }
`

export const SubContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 300px;
  box-shadow: 0px 2px 10px -6px #252525;
  background-color: #F7F7F7;
  border-radius: 15px;
  padding: 10px;
`

export const RatingContainer = styled.div`
  display: flex;
  position: absolute;
  top: -10px;
  right: -10px;
  height: 30px;
  padding: 0px 12px 0px 10px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border: 1px solid #EEEEEE;
  border-radius: 15px;
  background-color: #FFFFFF;

  h3 {
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
    text-align: center;
    margin: 0px;
  }
`

export const TabStickyContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #FFFFFF;
  padding: 0px 40px;
  margin-bottom: 0px;
  position: sticky;
  top: 0px;
  z-index: 3;
`

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: space-between;
  width: 960px;
  background-color: #F7F7F7;
  box-shadow: 0px 2px 10px -6px #252525;
  padding: 10px;
  border-radius: 15px;
`

export const AddressContainer = styled.div`
  width: 100%;
  position: relative;
`

export const LoadingBackdrop = styled.div`
  position: absolute;
  top: -8px;
  left: -5px;
  width: 950px;
  height: 106px;
  background-color: #FFFFFFAA;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 5;
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: ${({ width }) => width || 840}px;
  background-color: #F7F7F7;
  box-shadow: 0px 2px 10px -6px #252525;
  padding: 10px;
  border-radius: 15px;
  margin-bottom: 20px;
`

export const FormField = styled(Container)`
  flex: ${props => props.stretch ? props.stretch : 1};
  justify-content: flex-end;
  padding: 0px;
`

export const Row = styled(Container)`
  width: 100%;
  position: relative;
  flex-direction: row;
  align-items: flex-start;
  margin-bottom: 15px;
  padding: 0px;
  gap: 10px;
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;
  gap: 5px;
`

export const InputIcon = styled.div`
  position: absolute;
  top: 8px;
  left: 18px;
`

export const ImageContainer = styled.button.attrs ({
  type: 'button'
})`
  width: 90px;
  display: flex;
  background-color: transparent;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  align-self: center;
  position: relative;
  border: 0px;
  margin: 2px 0px 15px;
`

export const Grid = styled.div`
  display: grid;
  grid-template-rows: 23px repeat(${({ numRows }) => numRows} , 1fr);
  grid-template-columns: 150px repeat(${({ numColumns }) => numColumns} , 1fr) 120px;
  justify-content: center;
  align-items: center;
  row-gap: 3px;
  width: 100%;
  padding: 0px;
  margin-bottom: 8px;
`

export const Image = styled.img`
  width: 20px;
  height: 20px;
  margin: 0px 8px 3px 0px;
`

export const BigImage = styled.img`
  width: 90px;
  height: 90px;
  box-shadow: 0px 2px 10px -6px #252525;
  border-radius: 15px;
`

export const Title = styled.h2`
  font-size: 16px;
  font-weight: 500;
  margin: 7px 0px 0px;
  align-self: center;
`

export const SubTitle = styled.h3`
  font-size: 16px;
  font-weight: 500;
  margin: 0px 0px 15px;
  align-self: center;
`

export const InfoText = styled.p`
  color: #000000;
  font-size: 14px;
  text-align: center;
  margin-bottom: 5px;
`

export const Label = styled.label`
  text-align: center;
  color: #000000;
  margin: 0px;

  &:hover {
    cursor: pointer;
  }
`

export const GridLabel = styled(Label)`
  margin-bottom: 3px;

  &:hover {
    cursor: default;
  }
`

export const LinkText = styled(Link)`
  color: #35A7FF;
  text-decoration: none;
  font-size: 14px;

  &:hover {
    color: #2875E2;
  }
`

export const MoneyText = styled(SubTitle)`
  color: #44CF6C;
`

export const WarningText = styled.p`
  margin: 0px;
  text-align: center;
  font-size: 14px;
  font-weight: 200;
  color: #FF3939;
`

export const ErrorContainer = styled.div`
  padding: 8px;
  margin-bottom: 20px;
  width: 100%;
  border-radius: 15px;
  text-align: center;
  background-color: #FF3939;

  p {
    color: #FFFFFF;
    margin: 0px;
  }
`

export const Input = styled(BaseInput)`
  width: 100%;
`

export const MaskedInput = styled(BaseMaskedInput)`
  width: 100%;
`

export const Button = styled(LookButton).attrs(buttonLook({ variant: 'secondary' }))`
  width: 200px;
  align-self: center;
`

export const LinkButton = styled(Link)`
  width: 180px;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;
  background-color: #252525;
  color: #FFFFFF;
  font-size: 14px;
  padding: 8px 20px;
  border-radius: 15px;
  text-decoration: none;
  margin-bottom: 10px;
  gap: 8px;

  &:hover {
    background-color: #121212;
    color: #FFFFFF;
  }
`

export const MoneyTextMask = styled(NumericFormat).attrs (props => {
  return {
    value: props.value.toFixed (2).replace ('.', ','),
    thousandSeparator: '.',
    decimalSeparator: ',',
    displayType: 'text',
    prefix: 'R$ '
  }
})`
  color: #44CF6C;
  font-size: 16px;
  font-weight: bold;
  padding: 0px;
`
